import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { ConsumoFolha } from "../api/dto/consumo-folha";

@Injectable({
    providedIn: 'root'
})
export class ConsumoFolhaService{

    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + 'consumos-folha';

    buscarPorId(id?: number): Observable<ConsumoFolha> {
        return this.http.get<ConsumoFolha>(`${this.url}/${id}`);
    }

    listarPorEmpresaId(id?: number): Observable<ConsumoFolha[]> {
        return this.http.get<ConsumoFolha[]>(`${this.url}/empresa/${id}`);
    }

    listarPorEmpresaIdECompetencia(id?: number, competenciaTransacao?: Date): Observable<ConsumoFolha[]> {
        return this.http.get<ConsumoFolha[]>(`${this.url}/empresa/${id}/competencia-transacao/${competenciaTransacao?.toISOString()}`);
    }

    salvar(consumo?: ConsumoFolha): Observable<ConsumoFolha> {
        return this.http.post<ConsumoFolha>(this.url, consumo);
    }

    atualizar(consumo?: ConsumoFolha, id?: number): Observable<ConsumoFolha>{
        return this.http.put<ConsumoFolha>(`${this.url}/${id}`, consumo);
    }

    excluirParcela(idParcela?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/parcela/${idParcela}`);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${id}`);
    }

}